import { API } from "aws-amplify";
import store from "@/store";
import router from "../../router";

export async function getDashboard(ruc) {
  //console.log("export async function getConsultas()")

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/ec/dashboard/pacs"; //replace this with the path you have configured on your API
  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: {
      ruc: ruc,
      // OPTIONAL
    },
  };
  let result = await API.get(apiName, path, myInit);
  console.log(result);
  return result;
  //return result.data;
}

export async function postDashboard(from = 0, size = 1000, cursor = "") {
  //console.log("postDashboard() 2022");
  //console.log(store.getters.filters);
  //console.log("router.currentRoute.path", router.currentRoute.path);
  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/ec/dashboard/pacs"; //replace this with the path you have configured on your API

  if (!store.getters.filters.some((filter) => filter.field.value == "ano")) {
    let payload = {
      field: {
        label: "Año",
        value: "ano",
        component: "select",
        excludeInView: [],
      },
      param: [new Date().getFullYear().toString()],
      default_operator: "OR",
    };
    store.dispatch("addFilterAction", payload);
    //console.log("************************** NO hay un friltro de año");
  }

  // Excluidos los filtros que no pueden usarse en la vista seleccionada
  const filteredItems = store.getters.filters.filter((item) => {
    if (item.field.hasOwnProperty("excludeInView")) {
      return !item.field.excludeInView.includes(router.currentRoute.path);
    }
  });

  //console.log(filteredItems);

  let myInit = {
    body: {
      from,
      size,
      cursor,
      view: router.currentRoute.path,
      empresa: store.getters.empresa,
      //filtros: store.getters.filters,
      filtros: filteredItems,
      cpcs: store.getters.misCpcs.map(function(el) {
        return el.cpc;
      }),
    }, // replace this with attributes you need
    headers: {
      //Authorization: (await AmplifyModules.Auth.currentSession()).idToken.jwtToken
    }, // OPTIONAL
  };
  let result = await API.post(apiName, path, myInit);
  if (result.statusCode == 401) {
    store.dispatch("signOut");
  } else {
    return result;
  }

  /*   API.post(apiName, path, myInit)
    .then(response => {
      // Add your code here
      console.log(response);
      if (response.hasOwnProperty("error")) {
        this.setUIMessage(this.$Amplify.I18n.get(response.error), "error");
      } else {
        this.setUIMessage(
          this.$Amplify.I18n.get("La consulta se ha guardado correctamente"),
          "success"
        );
      }
    })
    .catch(error => {
      console.log(error.response);
    })
    .finally(function() {
      that.isLoading = false;
    }); */
}

export async function deleteDashboard(selected) {
  console.log("API export async function deleteEmpresa(selected) {");

  let apiName = process.env.VUE_APP_AWS_API_REST_NAME; // replace this with your api name.
  let path = "/empresas"; //replace this with the path you have configured on your API
  let myInit = {
    // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      selected: selected,
    }, // replace this with attributes you need
  };

  await API.del(apiName, path, myInit)
    .then((response) => {
      // Add your code here
      console.log(response);
      return response;
    })
    .catch((error) => {
      console.log(error.response);
      return error.response;
    });

  //let result = await API.delete(apiName, path, myInit);
  //console.log("resultado:",result);
}
